import { lazy } from 'react';

// Types
import { PaymentCardsDueToExpireMessagesProps as LazyComponentProps } from './PaymentCardsDueToExpireMessages.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "paymentCardsDueToExpireMessages" */ './PaymentCardsDueToExpireMessages'),
  ),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PaymentCardsDueToExpireMessages');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PaymentCardsDueToExpireMessages };
